import { IN_USER } from "./types"

export const loginUser = user => {
    return {
        type: IN_USER,
        payload: user,
    }
}